export default __webpack_public_path__ + "static/media/gifts.5a1e0be7.svg";